import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import { Actions as SCHEMEACTIONS } from "../../../store/actions/schemeActions";
import { TrashIcon, XMarkIcon } from "@heroicons/react/20/solid";
import Spinner from "../../common/Spinner";

const DeleteSchemeModal = ({ scheme, deleteScheme, closeModal, modalStatus, deleting }) => {
	if (!modalStatus) {
		return null;
	}

	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{
				display: "block",
				background: "rgba(0,0,0,0.4)",
				overflow: "auto",
			}}
		>
			<div
				className="modal-dialog"
				style={{ width: "30%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20 }}
						>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">Confirm Deletion of Scheme</h3>
						</div>
						<div
							className="block-content"
							style={{ paddingRight: 0, paddingTop: 0, paddingBottom: 0 }}
						>
							<div className="tab-pane active content">
								Are you sure you want to delete this scheme?
								<br />
								<b>Note: You must contact support to restore this scheme in the future</b>
							</div>
						</div>
						<div className="block-content">
							<div
								className="block buttons"
								style={{
									marginRight: "1em",
									textAlign: "right",
									marginBottom: "9em",
								}}
							>
								<button
									className="btn btn-danger pull-right"
									type="submit"
									onClick={() => deleteScheme(scheme.id)}
								>
									{deleting ? (
										<>
											<Spinner
												style={{ height: "1.5em", verticalAlign: "middle", float: "left" }}
												className="animate-spin -ml-1 mr-3 h-5 w-5 "
											/>
											<div style={{ float: "left" }}> Deleting </div>
										</>
									) : (
										<>
											<TrashIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
											<div style={{ float: "left" }}> Delete </div>
										</>
									)}
								</button>

								<div className="clearfix"></div>
							</div>
						</div>
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { deleteSchemeModal } = state.pensions.scheme;

	return {
		scheme: deleteSchemeModal?.scheme,
		modalStatus: deleteSchemeModal?.show,
		deleting: deleteSchemeModal?.deleting,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: (scheme) => dispatch(SCHEMEACTIONS.deleteSchemeModal(false, scheme)),
	deleteScheme: (schemeId) => dispatch(SCHEMEACTIONS.deleteScheme(schemeId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteSchemeModal);
